import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { SystemLanguage } from '@dss-libs/shared/type/common-types';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly translateService = inject(TranslocoService);

  setLanguage(language: SystemLanguage) {
    this.translateService.setActiveLang(language);
  }

  getLanguage(): SystemLanguage {
    return this.translateService.getActiveLang() as SystemLanguage;
  }
}
